import styled from "styled-components";
import { Drawer, Box } from "@mui/material";

export const DrawerStyled = styled(Drawer)`
  display: flex;
  background-color: #f6f6fe !important;
  .MuiDrawer-paper {
    width: ${({ drawerWidth }) => drawerWidth} !important;
    transition: width 0.3s ease-in-out;
    /* Use absolute positioning only when expanded */
    position: ${({ expanded }) =>
      expanded ? "absolute" : "static"} !important;
    top: ${({ expanded }) => (expanded ? "2px" : "unset")} !important;
    left: ${({ expanded }) => (expanded ? "0" : "unset")} !important;
    z-index: ${({ expanded }) => (expanded ? "999" : "0")};
    border: none !important;
    background-color: #f6f6fe !important;
    padding: 16px 36px;
  }
`;

export const DrawerContent = styled(Box)`
  background-color: #f6f6fe !important;
  gap: 24px;
  display: flex;
  flex-direction: column;
  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .button {
    padding: 0 !important;
  }
`;

export const ExpandedContent = styled(Box)`
  /* margin-top: 16px; */
`;

export const CollapsedContent = styled(Box)`
  /* margin-top: 16px; */
`;
